export const GET_LIST_OF_CATEGORIES =
  'src/modules/competencies/GET_LIST_OF_CATEGORIES';
export const APPLY_PAGINATION =
  'src/modules/competencies/APPLY_PAGINATION';
export const CANCEL_ALL_API_REQUESTS =
  'src/modules/competencies/CANCEL_ALL_API_REQUESTS';

